import React from 'react';
import { IconArmchair } from '@tabler/icons-react';

import { ReservationRow, ReservationRowText } from '../styles';

export type ReservationResourceRowProps = {
  resources: string;
};

export const ReservationResourceRow = (props: ReservationResourceRowProps) => {
  const { resources } = props;

  return (
    <ReservationRow data-testid='reservation-resources'>
      <IconArmchair size={20} aria-hidden />
      <ReservationRowText>{resources}</ReservationRowText>
    </ReservationRow>
  );
};

export default ReservationResourceRow;
